<div class="container-fluid">
    <div class="d-flex align-items-center vh-100 justify-content-center">
        <div class="text-center">
            <img class="w-75" src="assets/images/page-not-found.png" />
            <div class="col-12">
                <h1 class="text-danger">404</h1>
                <h2>{{'UI_OOPS_PAGE_NOT_FOUND' | translate}}</h2>
            </div>

            <div class="col-12 mt-4">
                <a class="btn btn-outline-danger me-md-2" routerLink='/'>{{'UI_RETURN_HOME' | translate}}</a>
            </div>
        </div>
    </div>
</div>